module.exports = {
    // basic
    'output-format': 'output format',
    'an-output-format': 'an output format',
    'new-entry-type': 'new entry type',
    'months-previous': 'months previous',
    'date-ranges': 'date ranges',
    'schedule': 'schedule',
    'export': 'export',
    'exports': 'exports',
    'prod-data-export': 'production data export',
    'distribution': 'distribution',
    'prod-data-distribution': 'production data distribution',
    'prod-data-access-review': 'production data access review',
    'column': 'column',
    'new-company': 'new company',
    'current-month-inclusive': 'current month inclusive',
    'allowed-data-columns': 'allowed data columns',
    'column-name': 'column name',
    'well-property': 'well property',
    'time-of-data-delivery': 'time of data delivery',
    'days-of-data-delivery': 'days of data delivery',

    // raw
    'prod-delete-saved-export': 'Are you sure you want to delete this saved export?',
    'prod-export-no-data': 'No data found matching that search criteria.',
    'prod-data-export-columns-help': `For each of the columns specified in the output format you have selected, you must select what data will be shown. Any column with no <b>Source</b> selection will appear empty in the output file.`,
    'prod-data-export-company-help': `<b>Company</b> selects which company's data you want to include in the output.`,
    'prod-data-export-limits-help': 'You can limit data to specific assets, pads or wells, below.',
    'prod-data-export-entry-type-help': `
        <ul>
            <li>
                <b>Entry Type</b> selects which entry type
                you want to include in the output.
            </li>
            <li>
                <b>Column Mapping</b> controls how each
                data property is mapped from the
                source format to your selected output
                format.
            </li>
        </ul>
    `,
    'search-name-required': 'Please enter a search name',
    'days-value-required': 'Please enter days value',
    'months-value-required': 'Please enter months value',
    'date-ranges-help': '<b>Date Ranges</b> controls set the range of data included in the output.',
    'prod-data-export-file-name-help': `
        <b>File Name</b> allows you to specify the name of the file you will receive
        whenever downloading data after loading this saved export, or when
        receiving the data from this export on a schedule.
    `,
    'prod-output-format-help': `
        Here you can define exactly which columns are included in the data you download (or receive on a schedule). For each
        column, you can either enter your own <b>Column Name</b>, or you can select an existing <b>Well Property</b> (ie. Company, Pad, Asset, etc).<br />
        If you enter your own <b>Column Name</b>, you will be able to select what data goes in that column on the Production Data Export page.<br />
        If you select a <b>Well Property</b>, the data in that column will be automatically filled in.
    `,
    'column-required': `Please enter at least one column.`,
    'format-name-required': `Please enter a format name.`,
    'download-failed': 'Download failed.',

    // template
    'output-format-help': (words) => `
        <p>
            <b>Output Format</b> allows you to select from <a href="#prodOutputFormat/user/${words[0]}">your list of predefined output formats</a> to control how you want the data to appear in the CSV file that you download or schedule to be delivered to you.
        </p>
        <p>
            If you don't define or select an output format, the data will be in its original format.
        </p>
        <p>
            If your search criteria specifies multiple entry types or companies, and you want that to appear in a single output file, you must select an Output Format (as well as a <b>Column Mapping</b>, below). Otherwise, the output will be a zip archive of multiple files, each containing the data in its original format.
        </p>
    `,
    'month-range-help': (words) => `The output will include data uploaded between ${words[0]} and ${words[1]}`,
    'prod-data-export-time-zone-help': (words) => `The default time zone is CST. If you want to use a different one, change the <b>Time Zone</b> setting on the <a href="#myAccount/${words[0]}">My Account</a> page.`,
    'prodDataAccessReviewDetail': (words) => `Production Data Access Review for ${words[0]}`,
    'column-name-matches-built-in-property': (columnName) => `${columnName} matches the name of a built-in property. Please use another name.`,
};
